(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walter-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.walter-marquee').forEach((marquee) => {
    const toggle = marquee.querySelector('.walter-marquee__toggle');
    if (!toggle || toggle.dataset.initialized === 'true') return;

    toggle.dataset.initialized = 'true';
    toggle.addEventListener('click', () => {
      const isPaused = marquee.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', String(isPaused));
      toggle.setAttribute('aria-label', isPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
